package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices

import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class ClosingTypeEnum(val value: String) {
    WITH_CASH_REPORT(value = ApiUtils.Field.withCashReport),
    STANDARD(value = ApiUtils.Field.standard),
    WITHOUT_CASH(value = ApiUtils.Field.withoutCash),
    WITH_CASH_REPORT_AND_COUNT_PROTOCOL(value = ApiUtils.Field.withCashReportAndCountProtocol),
    STANDARD_WITHOUT_PRINTING(value = ApiUtils.Field.standardWithoutPrinting);

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                WITH_CASH_REPORT -> strings.withCashReport
                STANDARD -> strings.standard
                WITHOUT_CASH -> strings.withoutCash
                WITH_CASH_REPORT_AND_COUNT_PROTOCOL -> strings.withCashReportAndCountProtocol
                STANDARD_WITHOUT_PRINTING -> strings.standardWithoutPrinting
            }
        }
}